import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { Button } from './button';

interface NotFoundProps {
  title?: string;
  message?: string;
}
const NotFound = ({ title, message }: NotFoundProps) => {
  const { t } = useTranslation('common');
  return (
    <div className='min-h-screen flex items-center justify-center bg-background'>
      <div className='max-w-md p-8 bg-card rounded-lg shadow-lg text-center border border-border'>
        <div className='text-6xl mb-4'>🔍</div>
        <h1 className='text-3xl font-bold text-foreground mb-4'>{title || t('notFound.title')}</h1>
        <p className='text-muted-foreground mb-6'>{message || t('notFound.message')}</p>

        <div className='flex flex-col sm:flex-row gap-3 justify-center'>
          <Link to='/'>
            <Button>{t('notFound.goHome')}</Button>
          </Link>
          <Button variant='outline' onClick={() => window.history.back()}>
            {t('notFound.goBack')}
          </Button>
        </div>

        {import.meta.env.DEV && (
          <details className='mt-6 text-left'>
            <summary className='cursor-pointer font-medium text-muted-foreground'>{t('notFound.debugInfo')}</summary>
            <div className='mt-2 text-xs text-muted-foreground'>
              <p>
                {t('notFound.currentUrl')}: {window.location.pathname}
              </p>
              <p>
                {t('notFound.timestamp')}: {new Date().toISOString()}
              </p>
            </div>
          </details>
        )}
      </div>
    </div>
  );
};

export default NotFound;
